module.exports = new __parcel__URL__("odiac--dataset-cover.63bc8865.jpg").toString();